const EASE = {
  linear: (t: number) => t,
  easeInOut: (t: number) => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  easeInQuad: (t: number) => t * t,
  easeOutQuad: (t: number) => t * (2 - t),
  easeInOutQuad: (t: number) => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
  easeInCubic: (t: number) => t * t * t,
  easeOutCubic: (t: number) => (--t) * t * t + 1,
  easeInOutCubic: (t: number) => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  easeInQuart: (t: number) => t * t * t * t,
  easeOutQuart: (t: number) => 1 - (--t) * t * t * t,
  easeInOutQuart: (t: number) => t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t,
  easeInQuint: (t: number) => t * t * t * t * t,
  easeOutQuint: (t: number) => 1 + (--t) * t * t * t * t,
  easeInOutQuint: (t: number) => 1 + (--t) * t * t * t * t,
  easeInElastic: (t: number) => (.04 - .04 / t) * Math.sin(25 * t) + 1,
  easeOutElastic: (t: number) => .04 * t / (--t) * Math.sin(25 * t),
  easeInOutElastic: (t: number) => (t -= .5) < 0 ? (.01 + .01 / t) * Math.sin(50 * t) : (.02 - .01 / t) * Math.sin(50 * t) + 1,
}

export const SmoothScrollToElement = (element: HTMLElement, callback?: () => void, scrollPaddingTop?: number, topPulas?: number) => {
  const SPEED = 500

  const bodyOrHtml = () => {
    return document.documentElement.scrollTop || document.body.scrollTop
  }

  const getTop = (element: HTMLElement) => {
    return element.getBoundingClientRect().top + bodyOrHtml()
  }

  const currentPostion = bodyOrHtml()
  const targetElement = element

  const targetPosition = getTop(targetElement) - (scrollPaddingTop || 0) + (topPulas || 0)
  const startTime = performance.now()

  const loopFunction = (nowTime: number) => {
    const time = nowTime - startTime
    const normalizedTime = time / SPEED
    if (normalizedTime < 1) {
      window.scrollTo(0, currentPostion + ((targetPosition - currentPostion) * EASE.easeInOut(normalizedTime)))
      requestAnimationFrame(loopFunction)
    } else {
      window.scrollTo(0, targetPosition)
      if (callback) {
        callback()
      }
    }
  }

  requestAnimationFrame(loopFunction)
}